import './riskTypes.scss'
import { Box, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { RiskLevelSlider } from '../../../../../components/utilities/RiskLevelSlider'

const RiskTypes = () => {
  const { t } = useTranslation(['messages'])

  return (
    <Paper elevation={0} className="risk-types-paper">
      <Box className="risk-types-row">
        <RiskLevelSlider type="NOT_DEFINED" displayTitle={false} />
        <Typography variant="subtitle4">{t('messages:riskNotDefinedDescription')}</Typography>
      </Box>
      <Box className="risk-types-row">
        <RiskLevelSlider type="LOW" displayTitle={false} />
        <Typography variant="subtitle4">{t('messages:riskLowDescription')}</Typography>
      </Box>
      <Box className="risk-types-row">
        <RiskLevelSlider type="MEDIUM" displayTitle={false} />
        <Typography variant="subtitle4">{t('messages:riskMediumDescription')}</Typography>
      </Box>
      <Box className="risk-types-row">
        <RiskLevelSlider type="HIGH" displayTitle={false} />
        <Typography variant="subtitle4">{t('messages:riskHighDescription')}</Typography>
      </Box>
      <Box className="risk-types-row">
        <RiskLevelSlider type="VERY_HIGH" displayTitle={false} />
        <Typography variant="subtitle4">{t('messages:riskVeryHighDescription')}</Typography>
      </Box>
    </Paper>
  )
}

export default RiskTypes
